import { useTranslation } from "react-i18next";
import { rpeStoredToDisplay } from "../../inputs/RpeInput";

/**
 * One-line hint above the set entry row saying what Enter will do.
 */
const SetRowHint = ({
  primary,
  selectedExercise,
  newSet,
  intensityMeasure,
  isRiR,
  rowValid,
  rowEmpty,
  exerciseHasSets,
  queueEnabled,
  exerciseName,
}) => {
  const { t } = useTranslation("coaching-portal");
  let hint = null;

  if (rowValid) {
    if (primary === "assistant" && selectedExercise?.parameters) {
      hint = t("addExerciseModal.hintAddSetGeneric", {
        exercise: exerciseName,
      });
    } else {
      const reps = [newSet.reps, newSet.repsTwo, newSet.repsThree]
        .filter(Boolean)
        .join("+");
      const intensity =
        newSet.rpe === "AMRAP"
          ? "AMRAP"
          : newSet.rpe
            ? `${intensityMeasure} ${rpeStoredToDisplay(newSet.rpe, isRiR)}`
            : "";
      const summary = `${newSet.sets} × ${reps || "AMRAP"}${
        intensity && reps ? ` @ ${intensity}` : ""
      }`;
      hint = t("addExerciseModal.hintAddSet", {
        summary,
        exercise: exerciseName,
      });
    }
  } else if (rowEmpty && exerciseHasSets && queueEnabled) {
    hint = t("addExerciseModal.hintAddToWorkout", { exercise: exerciseName });
  }

  if (!hint) return null;
  return (
    <p className="add-set-hint" aria-live="polite">
      {hint}
    </p>
  );
};

export default SetRowHint;
